export default {
  message: {
    "Loading": "加載中...",
    "PaymentConfirming": "檢查交易狀態...",
    "Check": "檢查",
    "CheckFail": "交易未完成。請在5秒後再次檢查。",
    "secondsago": "{time}秒前",
    "Addname": "將'{name}'添加到您的名稱",
    "Restattcheck": "重新啟動應用以檢查",
    "Copyname": "複製'{name}'",
    "SubmissionFailed": "提交失敗，請稍後再試",
    "WithdrawalReview": "提現審核",
    "WebWithdrawAwaitTip": "* 預計需要24-48小時。邀請更多朋友可以加快審核過程。",
    "Success": "成功",
    "Rejection": "拒絕",
    "WebSubmittedTip": "已提交，我們會儘快處理。",
    "select_payment_method": "選擇支付方式",
    "total_amount": "總金額",
    "next_step": "下一步",
    "creating_order": "正在創建訂單...",
    "order_created": "訂單已創建",
    "order_status": "訂單狀態",
    "order_id": "訂單ID",
    "order_amount": "訂單金額",
    "order_status_desc": "訂單狀態描述",
    "payment_cancelled": "支付已取消",
    "opening_payment": "正在打開支付...",
    "payment_success": "支付成功",
    "payment_failed": "付款失敗",
    "payment_pending": "付款待處理",
    "payment_processing": "付款處理中",
    "create_order_failed": "創建訂單失敗",
    "creating_ton_order": "正在創建TON訂單...",
    "check_payment_status": "正在檢查付款狀態...",
    "use_ton_payment": "使用TON付款",
    "connect_wallet": "連接錢包",
    "start_transaction": "開始交易",
    "address": "地址",
    "amount_ton": "金額TON",
    "copy": "複製",
    "comment_memo": "註解備忘",
    "comment_memo_desc": "請輸入註解備忘",
    "comment_memo_placeholder": "輸入註解備忘",
    "amount": "金額",
    "wallet_address": "錢包地址",
    "you_can_choose_to_connect_wallet_to_pay": "您可以選擇連接錢包付款",
    "or_manually_transfer_to_the_above_address": "或手動轉賬到上述地址（請注意金額和備忘必須完全相同）",
    "transaction_success": "交易成功",
    "transaction_failed": "交易失敗",
    "transaction_error": "交易錯誤",
    "transaction_status": "交易狀態",
    "transaction_id": "交易ID",
    "transaction_amount": "交易金額",
    "transaction_status_desc": "交易狀態描述",
    "miner_detail": "礦工詳細信息",
    "rent_period": "租賃期間",
    "days": "{days} 天",
    "daily_yield": "每日收益",
    "total_yield": "總收益",
    "invite_friends": "邀請朋友",
    "price": "價格",
    "rent": "租金",
    "free_claim": "免費領取",
    "redeem": "兌換",
    "buy": "租賃",
    "invite_friends_not_enough": "邀請朋友不足",
    "redeem_success": "兌換成功",
    "redeem_failed": "兌換失敗",
    "rent_success": "租賃成功",
    "rent_failed": "租賃失敗",
    "Insufficient": "邀請人數不足",
    "InsufficientMsg": "您需要邀請 {num} 位朋友以獲得更多配件。",
    "TotalPower": "總功率",
    "MaxQuantity": "最大值已達到",
    "Running": "運行中",
    "Stop": "停止",
    "error": "哎呀！發生了一些錯誤。",
    "Sorrysomeerrorsoccurred": "發生了意外錯誤。您可以嘗試切換語言或退出並重新啟動應用程式。",
    "quit": "退出",
    "language": "語言",
    "Youcanchangethelanguagehere": "您可以在這裡更改語言！",
    "current": "當前",
    "home": "主頁",
    "friends": "好友",
    "wallet": "錢包",
    "aboutus": "關於我們",
    "Sharewithfriends": "與朋友分享",
    "copyFailure": "複製失敗",
    "copySuccess": "複製成功",
    "Claimreward": "領取獎勵",
    "DailyLogin": "每日登錄",
    "noInvitationsYet": "尚未有邀請",
    "LoadMore": "加載更多",
    "WatchAD": "觀看廣告",
    "continue": "繼續",
    "Congratulations": "恭喜",
    "MyFriends": "我的好友",
    "Invitefriends": "邀請朋友",
    "Invitepremiumfriends": "邀請高級朋友",
    "DailyTasks": "每日任務",
    "inviteDesc": "每邀請一位朋友可獲得 +{num} ${name}",
    "DailyTasksDesc": "完成任務以獲得更多空投",
    "SponsorsandPartners": "贊助商和合作夥伴",
    "Receivingwallet": "接收錢包",
    "Enterwalletaddress": "輸入 {name} 錢包地址",
    "Claim": "領取",
    "Booster": "增強器",
    "RentPeriod": "租用期間",
    "days30": "30天",
    "Dailyprofit": "每日利潤",
    "Totalprofit": "總利潤",
    "Quantity": "數量",
    "RentPrice": "租金價格",
    "RentMiner": "租用礦工",
    "Settings": "設置",
    "copyid": "複製ID",
    "UpgradeSuccessfully": "升級成功",
    "Name": "名稱",
    "userinfo": "用戶資訊",
    "disconnect": "斷開連接",
    "Startmining": "開始挖礦",
    "Welcome": "歡迎來到 {name}",
    "Withdrawal": "提款",
    "Minimumamount": "最低金額",
    "Networkfee": "網絡費用",
    "Enteramount": "輸入金額",
    "Submit": "提交",
    "MinimumTip": "提現金額過小。最低提現金額：{num}",
    "MaximumTip": "金額不足，您最多可提現的金額為：{num}",
    "SubmittedTip": "已提交，預期在30-60個工作日內處理完畢",
    "WithdrawStatus": "狀態",
    "Submissiontime": "提交時間",
    "WithdrawAwaitTip": "* 預計需要30-60個工作日。邀請更多朋友可以加快審核過程。",
    "Processing": "處理中",
    "Amount": "金額",
    "Numberoffriends": "朋友數量：{now}/{limit}",
    "InviteTip": "要進行首次提現，您需要邀請{limit}位朋友加入挖礦應用。",
    "openonphone": "在您的手機上打開這個鏈接。",
    "claimTip": "待收取的金額過小。最低待收取金額為：{num}",
    "WalletBalance": "錢包餘額",
    "Withdraw": "提現",
    "SetWalletAddress": "設置錢包地址",
    "WithdrawalRecord": "提現紀錄",
    "Norecords": "沒有紀錄",
    "Whatis": "什麼是{name}?",
    "All": "全部",
    "save": "保存",
    "successWithdrawal": "掃描成功 {num}",
    "Withdrawalunlock": "提款解鎖",
    "Close": "關閉",
    "Delivering": "發送中",
    "Duetothelargenumber": "由於接收者人數眾多，您的空投預計將在15-20個工作日內到達",
    "WithdrawalunlockTip": "您需要{num}位受邀朋友完成任務/綁定錢包以解鎖提款",
    "mining_title": "機器人",
    "Upgrade": "升級",
    "partner": "夥伴",
    "faq": "常見問題",
    "task": "任務",
    "OpenRobot": "開啟機器人",
    "MyRobot": "我的機器人",
    "Level": "等級",
    "Commission": "佣金",
    "DirectFriends": "直接朋友",
    "Feedback": "回饋",
    "Pleaseenteryouremailaddress": "請輸入您的電子郵件地址",
    "Inputfeedbackcontent": "輸入回饋內容",
    "Submitfeedback": "提交回饋",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "回饋提交成功，感謝您寶貴的回饋",
    "Feedbacksubmissionfailed,pleaseretriy": "回饋提交失敗，請再試一次",
    "Addressformaterror": "地址格式錯誤",
    "Readclipboardfailed": "讀取剪貼簿失敗",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "您今天已經回饋過，請明天再來",
    "Record": "紀錄",
    "Newuserguidance": "查看歡迎導覽",
    "Usetonwallet": "使用 TON 錢包",
    "Reward": "獎勵",
    "Connectwallet": "連接錢包",
    "Notconnected": "未連接",
    "Disconnect": "斷開連接",
    "AboutTAI": "代幣詳情",
    "WithdrawalRecordDesc": "提款紀錄",
    "StartAItrading": "開始 AI 交易",
    "Next": "下一步",
    "Start": "開始",
    "WithdrawalSuccess": "提款成功",
    "WithdrawalFail": "提款失敗",
    "Max": "最大",
    "WithdrawalRecords": "提款紀錄",
    "Commissionrules": "佣金規則",
    "Mycommission": "我的佣金",
    "Shop": "購物",
    "BuyDifferentAIrobots": "升級計算設備以加快掃描速度！",
    "CurrentRunningAIrobots": "目前運行中的AI機器人",
    "DailyProfit": "每日利潤",
    "Buy": "購買",
    "ValidityPeriod": "有效期",
    "Days": "天",
    "Price": "價格",
    "APY": "年化收益率",
    "NoRobot": "沒有計算能力",
    "RemainingTime": "剩餘時間",
    "InviteandEarn": "邀請並賺取",
    "InvitDec": "邀請你的朋友加入AI交易，並一起賺取USDT佣金和空投代幣！",
    "ShareToGroups": "分享至群組",
    "Select_payment_method": "選擇付款方式",
    "twa_pay_tip_with_memo": "請確保地址、金額及備註在轉帳時一致。",
    "twa_pay_tip": "請確保地址及金額在轉帳時正確。",
    "twa_pay_tip_placeholder": "輸入評論備註",
    "twa_pay_tip_placeholder_with_memo": "輸入包含備註的評論備註",
    "twa_pay_tip_placeholder_without_memo": "輸入不包含備註的評論備註",
    "twa_pay_tip_placeholder_with_memo_placeholder": "輸入包含備註的評論備註",
    "twa_pay_tip_placeholder_without_memo_placeholder": "輸入不包含備註的評論備註",
    "realtime_ai": "實時 AI 交易",
    "check_transaction_status": "檢查交易狀態",
    "transaction_wait": "交易正在處理中。您可以退出應用程式。完成後將有訊息通知您。",
    "Pleaseenteravalidemailaddress": "請輸入有效的電子郵件地址",
    "max_robot_tip": "已達購買限制 — 嘗試其他方案繼續交易！",
    "connectFailure": "連接錢包失敗",
    "connectSuccess": "連接錢包成功",
    "PayNow": "立即支付",
    "min_withdrawal_amount": "最低提現金額為 {num} {coin_name}",
    "max_withdrawal_amount": "最高提現金額為 {num} {coin_name}",
    "balance_not_enough": "您的餘額不足以進行此提現。",
    "Numberofgroups": "組數： {now}/{limit}",
    "Withdraw_success": "提現成功",
    "allProfit": "總收益",
    "AnnualProfit": "年度利潤",
    "ScanWallet": "掃描錢包",
    "wallet_check": "wallet_check",
    "Found": "找到",
    "ScanSpeed": "掃描速度",
    "MyComputingPower": "計算",
    "Scanning": "掃描中！",
    "WithdrawDetail": "提款詳細資訊",
    "ScanSuccess": "您的掃描成功率已提升！",
    "TaskDescription": "完成任務以提高您的掃描成功率！",
    "InitializingMiningSystem": "初始化掃描系統...",
    "NoWithdrawalRecord": "無提款紀錄",
    "Invite": "所需邀請",
    "Free": "免費",
    "Confirm": "確認",
    "RefreshTasks": "重新整理任務",
    "NumberofGroups": "群組數量： {now}/{limit}",
    "SendMessage": "發送訊息",
    "NumberofShares": "分享數量： {now}/{limit}",
    "NumberofTasks": "任務數量： {now}/{limit}",
    "CompleteTask": "完成任務",
    "Accelerated": "加速",
    "Accelerated_withdrawals_success": "成功加速提取",
    "GoBuy": "去購買",
    "SpeedUpScan": "加速",
    "Earnings": "收益",
    "learnMore": "瞭解更多",
    "claimSuccess": "成功領取",
    "claimFailed": "領取失敗，請再試一次",
    "noDividends": "沒有可領取的紅利",
    "dividendsInfoFallback": "邀請朋友賺取推薦獎勵"
}};